import React, { useState, useEffect } from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  Dialog,
  DialogContent,
  TextField,
  Button,
  Grid,
  Box,
  IconButton,
  Typography,
  Slide,
  useTheme,
  styled,
  Stack,
  useMediaQuery,
  Snackbar,
  Alert,
  InputLabel,
  Checkbox,
  FormControlLabel,
  Link,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import callBackFormSubmit from "../services/callBackFormSu";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    borderRadius: "20px",
    padding: "20px",
    maxWidth: "500px",
    width: "90%",
    background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
    boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
    [theme.breakpoints.down("sm")]: {
      margin: "10px",
      width: "calc(100% - 20px)",
      maxWidth: "none",
      padding: "15px",
      borderRadius: "15px",
    },
  },
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: "12px",
    backgroundColor: "white",
    "& fieldset": {
      borderColor: "#e0e0e0",
    },
    "&:hover fieldset": {
      borderColor: "#00cc87",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#00cc87",
    },
  },
  "& .MuiInputLabel-root": {
    color: "#666",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "#00cc87",
  },
}));

const StyledButton = styled(Button)(({ theme }) => ({
  borderRadius: "12px",
  padding: "5px 30px",
  fontSize: "16px",
  marginTop: "20px",
  fontWeight: "bold",
  textTransform: "none",
  background: "linear-gradient(45deg, #00cc87 30%, #f44336 90%)",
  boxShadow: "0 8px 20px rgba(211, 47, 47, 0.3)",
  "&:hover": {
    background: "linear-gradient(45deg, #b71c1c 30%, #00cc87 90%)",
    boxShadow: "0 12px 25px rgba(211, 47, 47, 0.4)",
    transform: "translateY(-2px)",
  },
  transition: "all 0.3s ease",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    padding: "8px 20px",
    fontSize: "14px",
    marginTop: "15px",
  },
}));

const FileUploadButton = styled(Button)(({ theme }) => ({
  borderRadius: "12px",
  padding: "8px 20px",
  fontSize: "14px",
  fontWeight: "bold",
  textTransform: "none",
  backgroundColor: "white",
  color: "#00cc87",
  border: "2px dashed #00cc87",
  "&:hover": {
    backgroundColor: "rgba(211, 47, 47, 0.1)",
    border: "2px dashed #b71c1c",
  },
  transition: "all 0.3s ease",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    padding: "6px 16px",
    fontSize: "12px",
  },
}));

const CloseButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  right: 8,
  top: 8,
  color: "#666",
  "&:hover": {
    backgroundColor: "rgba(211, 47, 47, 0.1)",
    color: "#00cc87",
  },
  [theme.breakpoints.down("sm")]: {
    right: 5,
    top: 5,
    padding: "4px",
    "& .MuiSvgIcon-root": {
      fontSize: "18px",
    },
  },
}));

export default function CareerPopUp({ open, handleClose }) {
  const [formData, setFormData] = useState({
    name: "",
    "email-address": "",
    "phone-number": "",
    resume: null,
    comments: "",
    "form-name": "PopUp Loan Form",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // Show popup after specified time

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Check file type (PDF, DOC, DOCX)
      const allowedTypes = [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ];

      // Check file size (5MB max)
      const maxSize = 5 * 1024 * 1024; // 5MB in bytes

      if (!allowedTypes.includes(file.type)) {
        setSnackbar({
          open: true,
          message: "Please upload a PDF, DOC, or DOCX file only.",
          severity: "error",
        });
        return;
      }

      if (file.size > maxSize) {
        setSnackbar({
          open: true,
          message: "File size should be less than 5MB.",
          severity: "error",
        });
        return;
      }

      setFormData((prev) => ({
        ...prev,
        resume: file,
      }));
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    try {
      // First API call (your existing one)
      await callBackFormSubmit(formData);

      // Second API call for email (new)
      const emailFormData = new FormData();

      // Map your form fields to the email API format
      emailFormData.append("smtpEmail", "psnfinanceblr@gmail.com");
      emailFormData.append("appPassword", "pnyl ysdr vfxk avmj");
      emailFormData.append("toEmail", "psnfinanceblr@gmail.com");
      emailFormData.append("subject", `New Application - ${formData.name}`);

      // Add resume file if exists
      if (formData.resume) {
        emailFormData.append("attachment", formData.resume);
      }

      // Create message content
      const message = `New application received.\n\nName: ${
        formData.name
      }\nEmail: ${formData["email-address"]}\nPhone: ${
        formData["phone-number"]
      }\nComments: ${formData.comments || "No comments provided"}\nResume: ${
        formData.resume ? formData.resume.name : "No file attached"
      }`;

      const html = `
        <h3>New Application</h3>
        <p><strong>Name:</strong> ${formData.name}</p>
        <p><strong>Email:</strong> ${formData["email-address"]}</p>
        <p><strong>Phone:</strong> ${formData["phone-number"]}</p>
        <p><strong>Comments:</strong> ${
          formData.comments || "No comments provided"
        }</p>
        <p><strong>Resume:</strong> ${
          formData.resume ? formData.resume.name : "No file attached"
        }</p>
      `;

      emailFormData.append("message", message);
      emailFormData.append("html", html);

      // Send email
      const emailResponse = await fetch(
        "https://email-sender.backendprod.com/api/send-email",
        {
          method: "POST",
          headers: {
            "X-API-Key": "Dinesh@@@@",
          },
          body: emailFormData,
        }
      );

      const emailResult = await emailResponse.json();

      if (!emailResult.success) {
        console.error("Email sending failed:", emailResult.error);
      }

      // Show success message
      setSnackbar({
        open: true,
        message: "Application submitted successfully!",
        severity: "success",
      });

      // Reset form after successful submission
      setFormData({
        name: "",
        "email-address": "",
        "phone-number": "",
        resume: null,
        comments: "",
        "form-name": "PopUp Loan Form",
      });
    } catch (error) {
      console.error("Submission error:", error);
      setSnackbar({
        open: true,
        message: "Failed to submit application. Please try again.",
        severity: "error",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <>
      <StyledDialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="loan-application-form"
      >
        <CloseButton onClick={handleClose}>
          <CloseIcon fontSize="small" />
        </CloseButton>

        <DialogContent
          sx={{
            p: isMobile ? 1 : 3,
            "&.MuiDialogContent-root": {
              paddingTop: isMobile ? "30px" : "inherit",
            },
          }}
        >
          <Box component="form" onSubmit={handleSubmit}>
            <Typography
              variant="subtitle1"
              sx={{
                fontSize: { xs: "1rem", md: "1.5rem" },
                fontWeight: "bold",
                mb: 2,
                textAlign: "center",
              }}
            >
              Apply Now
            </Typography>
            <Stack spacing={2} sx={{ mb: { xs: 1, md: 2 } }}>
              <StyledTextField
                required
                fullWidth
                size={isMobile ? "small" : "medium"}
                id="name"
                label="Name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                variant="outlined"
              />

              <StyledTextField
                size={isMobile ? "small" : "medium"}
                required
                fullWidth
                id="email-address"
                label="Email"
                name="email-address"
                type="email"
                value={formData["email-address"]}
                onChange={handleChange}
                variant="outlined"
              />
            </Stack>

            <Stack spacing={2} sx={{ mb: { xs: 1, md: 2 } }}>
              <StyledTextField
                required
                fullWidth
                size={isMobile ? "small" : "medium"}
                id="phone-number"
                label="Mobile No"
                name="phone-number"
                type="tel"
                value={formData["phone-number"]}
                onChange={handleChange}
                variant="outlined"
                inputProps={{ pattern: "[0-9]{10}" }}
              />

              {/* File Upload Section */}
              <Box>
                <InputLabel sx={{ mb: 1, color: "#666", fontSize: "14px" }}>
                  Resume/CV *
                </InputLabel>
                <input
                  type="file"
                  id="resume-upload"
                  accept=".pdf,.doc,.docx"
                  onChange={handleFileChange}
                  style={{ display: "none" }}
                  required
                />
                <label htmlFor="resume-upload">
                  <FileUploadButton component="span" fullWidth>
                    {formData.resume
                      ? formData.resume.name
                      : "Upload Resume/CV (PDF, DOC, DOCX)"}
                  </FileUploadButton>
                </label>
                <Typography
                  variant="caption"
                  sx={{ color: "#666", mt: 0.5, display: "block" }}
                >
                  Max file size: 5MB
                </Typography>
              </Box>
            </Stack>

            <Stack spacing={2} sx={{ mb: { xs: 1, md: 2 } }}>
              <StyledTextField
                fullWidth
                size={isMobile ? "small" : "medium"}
                id="comments"
                label="Comments"
                name="comments"
                value={formData.comments}
                onChange={handleChange}
                variant="outlined"
                multiline
                rows={3}
                placeholder="Any additional comments or information..."
              />
            </Stack>

            <Box sx={{ mt: 2, mb: 1 }}>
              <FormControlLabel
                control={<Checkbox required color="default" />}
                sx={{ '& .MuiFormControlLabel-asterisk': { display: 'none' } }}
                label={
                  <Typography component="span" variant="body1" sx={{ display: 'inline', fontSize: { xs: "12px", md: "14px" }, textAlign: "left" }}>
                    By continuing, you agree to provide your authorization to PSN Finance, PSN Group, and its affiliated entities to store and process your data as per the{" "}
                    <Link component={RouterLink} to="/privacy-policy" underline="hover" color="primary">
                      Privacy Policy*
                    </Link>
                    .
                  </Typography>
                }
              />
            </Box>

            <Grid item xs={12}>
              <Box sx={{ display: "flex", justifyContent: "center", mt: 1 }}>
                <StyledButton
                  type="submit"
                  variant="contained"
                  id="apply-btn-register"
                  size="small"
                  disabled={isSubmitting}
                  sx={{
                    width: { xs: "50%", md: "150px" },
                    fontSize: { xs: "14px", md: "16px" },
                  }}
                >
                  {isSubmitting ? "Submitting..." : "Apply"}
                </StyledButton>
              </Box>
            </Grid>
          </Box>
        </DialogContent>
        <Snackbar
          open={snackbar.open}
          autoHideDuration={6000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnackbar}
            severity={snackbar.severity}
            sx={{ width: "100%" }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      </StyledDialog>
    </>
  );
}
